/**
 * @generated SignedSource<<86f78b040ef6823dec733d914c0f081e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type AccountExtensionKind = "Academies";
export type Kind = "Assigment" | "FreeForAll";
import { FragmentRefs } from "relay-runtime";
export type licenseSettings_QueryFragment$data = {
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly accounts: ReadonlyArray<{
          readonly extension: {
            readonly kind: AccountExtensionKind;
            readonly licenseModelKind?: Kind | null;
          } | null;
          readonly id: string;
        }>;
      } | null;
    };
  };
  readonly " $fragmentType": "licenseSettings_QueryFragment";
};
export type licenseSettings_QueryFragment$key = {
  readonly " $data"?: licenseSettings_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"licenseSettings_QueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./licenseSettings_QueryFragmentRefetch.graphql')
    }
  },
  "name": "licenseSettings_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ViewerQueryType",
      "kind": "LinkedField",
      "name": "Viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthViewerSchema",
          "kind": "LinkedField",
          "name": "Auth",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CurrentUser",
              "kind": "LinkedField",
              "name": "currentUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Account",
                  "kind": "LinkedField",
                  "name": "accounts",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "accountExtensionKind",
                          "value": "Academies"
                        }
                      ],
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "extension",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "kind",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "licenseModelKind",
                              "storageKey": null
                            }
                          ],
                          "type": "AcademiesAccountExtension",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": "extension(accountExtensionKind:\"Academies\")"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "e7fa6b17ef3d73967dbc6f9d317ff552";

export default node;
